// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"49":"UptimeWorker","76":"VersionCheckerWorker"}[chunkId] + "." + {"49":"ec66fff4","76":"31dfe9d3"}[chunkId] + ".chunk.js";
};